<template>
    <div class="container">
        <div ref="qrcode" v-show="false">
            
        </div>

        <transition name="fade">
            <div class="bg" :style="{backgroundImage:'url('+bgImg1+')'}" v-if="show == 1" :key="1">
                <a href="javascript:;" class="btn1" @click="start"><img :src="btnImg1" alt="我要参加"></a>
            </div>
            
            <div class="bg" :style="{backgroundImage:'url('+bgImg2+')'}" v-if="show == 2" :key="2">
                <textarea v-model="message" class="msg hei" ref="message" @change="limitMessage"></textarea>
                <a href="javascript:;" class="btn2" @click="share"><img :src="btnImg2" alt="晒一晒"></a>
            </div>
        
            <!-- <div class="bg" v-if="show == 3" :key="3">
                <img :src="poster">
            </div> -->
        </transition>

        <van-popup v-model="showPoster" :close-on-click-overlay="false">
          <div class="poster">
            <img :src="poster">
          </div>
          <p class="tips">长按保存图片分享朋友圈</p>
          <a href="javascript:;" class="edit" @click="edit">返回编辑</a>
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { getStorage, setStorage, deleteStorage, isLocal, isMain } from "@/utils/tools"
import { userinfo } from '@/api/other';
import { shareCon } from "@/utils/wxconfig";
import bgImg1 from "@a/other/shengya/activity520/index.png";
import bgImg2 from "@a/other/shengya/activity520/cover.png";
// import bgImg3 from "@a/other/shengya/activity520/poster.png";
import btnImg1 from "@a/other/shengya/activity520/start.png";
import btnImg2 from "@a/other/shengya/activity520/share.png";

export default {
    data(){
        return{
            show: 0,
            bgImg1: bgImg1,
            bgImg2: bgImg2,
            bgImg3: isLocal() ? 'shengya_activity/activity520.png' : ('https://open.xjy.cn/' + (isMain() ? 'main' : 'test') + '/shengya_activity/activity520.png'),
            btnImg1: btnImg1,
            btnImg2: btnImg2,
            loadedAssets: [],
            progress: 0,
            nickname: null,
            loading: null,
            message: '',
            poster: null,
            showPoster: false
        }
    },
    methods:{
        pullData(){
            this.loading = Toast.loading({
                duration: 0,
                message: '加载中...\n0%',
                forbidClick: true,
            });

            userinfo().then(data=>{
                this.nickname = data.nickname;
                this.updateProgress();

                let imgs = [this.bgImg1, this.bgImg2, this.bgImg3, this.btnImg1, this.btnImg2,];
                for (let img of imgs) {
                    this.loadImg(img).then(image=>{
                        image.remove();

                        if(this.loadedAssets.indexOf(img) < 0) {
                            this.loadedAssets.push(img);
                        }
                        
                        this.updateProgress();
                    });
                }
            });
        },
        loadImg(image) {
            return new Promise((resolve, reject)=>{
                if(typeof image === 'string') {
                    let img = image;
                    image = document.createElement('img');
                    image.onload = () => {
                        resolve(image);
                    }
                    image.onerror = () => {
                        reject(image);
                    }
                    image.src = img;
                } else {
                    reject(image);
                }
            });
        },
        updateProgress() {
            this.progress = (this.nickname ? 50 : 0) + this.loadedAssets.length * 10;
            this.loading.message = `加载中...\n${this.progress}%`;

            if(this.progress >= 100) {
                this.loading.clear();
                this.display();
            }
        },
        display(){
            if(this.$route.query.reset) {
                deleteStorage(this.$route.path);
            }
            let message = getStorage(this.$route.path, 'message');
            if(message) {
                this.message = message;
                this.show = 2;
                this.share();
            } else {
                this.show = 1;
            }
        },
        start() {
            this.show = 2;
            this.$nextTick(()=>{
                window.scrollTo({top: 0});
                // this.$refs.message.focus();
            });
        },
        share() {
            if(!this.message) {
                this.$toast('请输入内容');
                return;
            }

            this.createPoster(this.message).then(poster=>{
                this.poster = poster;
                this.showPoster = true;
                setStorage(this.$route.path, 'message', this.message);
                this.$nextTick(()=>{
                    window.scrollTo({top: 0});
                });
            });
        },
        edit(){
            this.showPoster = false;
        },
        limitMessage() {
            if(this.message.length > 100) {
                this.message = this.message.substr(0, 100);
                this.$toast('最多输入100字');
            }
        },
        createPoster(message) {
            let qrcode = new QRCode(this.$refs.qrcode, {
                width: 80,
                height: 80,
            });
            qrcode.makeCode(window.location.href);

            return this.loadImg(this.bgImg3).then(bgImg => {
                return new Promise((resolve, reject) => {
                    let canvas = document.createElement('canvas');
                    canvas.width = 750;
                    canvas.height = 1334;

                    const ctx = canvas.getContext('2d');
                    // ctx.font = fontStyle;
                    // ctx.fillStyle = color;
                    ctx.textBaseline = "ideographic";
                    ctx.textAlign = 'start';

                    const fontHei = `-apple-system, "Noto Sans", "Helvetica Neue", Helvetica, "Nimbus Sans L", Arial, "Liberation Sans", "PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC", "Source Han Sans SC", "Source Han Sans CN", "Microsoft YaHei", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, "WenQuanYi Zen Hei Sharp", sans-serif`;
                    const fontMessage = `400 25px/38px "Alibaba PuHuiTi",${fontHei}`;
                    const fontSign = `400 16px/26px "Alibaba PuHuiTi",${fontHei}`;

                    const pink = '#FF4D73';
                    const black = '#000';

                    ctx.drawImage(bgImg, 0, 0);
                    bgImg.remove();

                    ctx.drawImage(qrcode._oDrawing._elCanvas, 335, 1147);
                    qrcode._oDrawing._elImage.remove();
                    qrcode._oDrawing._elCanvas.remove();

                    drawTextarea(ctx, this.message, 160, 661, 450, {font: fontMessage, fillStyle: pink}, 6, '...');
                    drawText(ctx, '收件人：新精英生涯', 217, 1252, {font: fontSign, fillStyle: black});
                    drawText(ctx, `寄件人：${this.nickname}`, 421, 1252, {font: fontSign, fillStyle: black});

                    let data = canvas.toDataURL("image/png");
                    canvas.remove();
                    resolve(data);

                    function getFontSize(style) {
                        let res = /(\d+)px\/(\d+)px/.exec(style.font);
                        return parseInt(res[1], 10);
                    }

                    function getLineHeight(style) {
                        let res = /(\d+)px\/(\d+)px/.exec(style.font);
                        return parseInt(res[2], 10);
                    }

                    function drawText(ctx, text, x, y, style) {
                        ctx.font = style.font;
                        ctx.fillStyle = style.fillStyle;

                        let pos = y + getLineHeight(style);
                        ctx.fillText(text, x, pos);
                        return pos;
                    }

                    function drawTextarea(ctx, text, x, y, width, style, max_line = 0, ellipsis = '') {
                        ctx.font = style.font;
                        ctx.fillStyle = style.fillStyle;

                        let wrappedText = wrapText(ctx, text, width, style, max_line, ellipsis);

                        let arr = wrappedText.split("\n");
                        for (let i = 0; i < arr.length; i++) {
                            y = drawText(ctx, arr[i], x, y, style);
                        }
                        return y;
                    }

                    function wrapText(ctx, text, width, style, max_line = 0, ellipsis = '') {
                        let count = Math.round(width / getFontSize(style));
                        let arr = text.split("\n");

                        arr = arr.map(v => {
                            let wrap_arr = [];
                            let start_count = 0;
                            let line_count = count;
                            let line = v.substr(start_count, line_count);
                            let remain_count = v.length - line.length;
                            let line_width = Math.floor(ctx.measureText(line).width);

                            while (true) {
                                if (line_width <= width) {
                                    while (line_width <= width && remain_count > 0) {
                                        line_count++;
                                        remain_count--;
                                        line = v.substr(start_count, line_count);
                                        line_width = Math.floor(ctx.measureText(line).width);
                                    }
                                    if (line_width > width) {
                                        line_count--;
                                        remain_count++;
                                    }
                                } else {
                                    while (line_width > width && line_count > 0) {
                                        line_count--;
                                        remain_count++;
                                        line = v.substr(start_count, line_count);
                                        line_width = Math.floor(ctx.measureText(line).width);
                                    }
                                }

                                line = v.substr(start_count, line_count);
                                wrap_arr.push(line);
                                if (remain_count <= 0) {
                                    break;
                                }

                                start_count += line_count;
                                line_count = count;
                                line = v.substr(start_count, line_count);
                                remain_count -= line.length;
                                line_width = Math.floor(ctx.measureText(line).width);
                            }

                            return wrap_arr.join("\n");
                        });

                        arr = arr.join("\n").split("\n");

                        if(max_line > 0 && arr.length > max_line) {
                            arr = arr.slice(0, max_line);

                            if(ellipsis != '') {
                                let line = arr[arr.length - 1];
                                
                                while(true) {
                                    let line_width = Math.floor(ctx.measureText(line + ellipsis).width);
                                    if(line_width <= width) {
                                        break;
                                    }
                                    line = line.substr(0, line.length - 1);
                                }

                                arr[arr.length - 1] = line + ellipsis;
                            }
                        }

                        return arr.join("\n");
                    }
                });
            });
        }
    },
    mounted() {
        document.title = '520告白季';

        this.pullData();
    }
}
</script>
<style lang="scss" scoped>
    .container {
        width: 100%;
        height: 100%;
    }

    .container ::v-deep .van-overlay {
        background-color: rgba(0,0,0,0.8) !important;
    }
    .container ::v-deep .van-popup {
        background-color: transparent;
    }

    .bg {
        width: 750px;
        height: 1334px;
        margin: 0 auto;
        position: relative;
        background-position: top center;
        background-repeat: no-repeat;
        background-size: 750px;

        img {
            width: 100%;
            height: 100%;
        }
    }
    .btn1 {
        position: absolute;
        right: 23px;
        bottom: 32px;

        img {
            width: 418px;
            height: 131px;
        }
    }
    .btn2 {
        position: absolute;
        top: 1079px;
        left: 50%;
        margin-left: -184px;

        img {
            width: 368px;
            height: 116px;
        }
    }
    .msg {
        width: 567px;
        height: 200px;
        font-size: 28px;
        font-weight: 400;
        color: #FF4D73;
        line-height: 40px;
        border: none;
        background: none;
        position: absolute;
        top: 789px;
        left: 100px;
    }
    .hei {
        font-family: "Alibaba PuHuiTi", -apple-system, "Noto Sans", "Helvetica Neue", Helvetica, "Nimbus Sans L", Arial, "Liberation Sans", "PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC", "Source Han Sans SC", "Source Han Sans CN", "Microsoft YaHei", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, "WenQuanYi Zen Hei Sharp", sans-serif;
    }
    .poster {
        width: 560px;
        height: 996px;
        margin: 0 auto;

        img {
            width: 100%;
            height: 100%;
        }
    }
    .tips {
        font-size: 36px;
        text-align: center;
        font-weight: 600;
        color: #fff;
        line-height: 50px;
        margin: 24px 0;
    }
    .edit {
        display: block;
        margin: 0 auto;
        box-sizing: border-box;
        width: 228px;
        height: 68px;
        border-radius: 43px;
        border: 1PX solid #B9B9B9;/*no*/
        line-height: 68px;
        color: #B9B9B9;
        text-align: center;
        font-size: 28px;
    }
</style>
<style type="text/css">
    .van-toast__text {
        text-align: center;
    }
</style>